import { Button } from "components";
import { useFormContext } from "react-hook-form";
import { FormSetStockGlobalType } from "../schemas/setStockGlobalSchema";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { useStoreSelectedRows } from "../../SetStockByLocation/store";
import { PERMISION } from "security";

export function CreateAllGlobal(props: {
    refecth?: () => void
}) {

    const api = useApi();

    const { selectedRows } = useStoreSelectedRows()

    const { getValues, trigger, formState } = useFormContext<FormSetStockGlobalType>()

    const onSubmit = async() => {
        const formItems = getValues("items") ?? [];

    const selectedIds = new Set(selectedRows.map(r => r.product_id));
    const selectedIndexes = formItems
        .map((item, index) =>
        selectedIds.has(item.product_id!) ? index : null
        )
        .filter((i): i is number => i !== null);

    // FE VALIDATION (hanya row yang dipilih)
    if (selectedIndexes.length > 0) {
        const paths = selectedIndexes.map(
        (i) => `items.${i}` as const
        );

        const isValid = await trigger(paths);

        if (!isValid) {
        selectedIndexes.forEach((i) => {
            const errors = formState.errors?.items?.[i];
            if (errors) {
            Object.values(errors).forEach((err: any) => {
                if (err?.message) toast.error(err.message);
            });
            }
        });
        return;
        }
    }

        const payload = formItems?.filter(item => selectedIds.has(item.product_id!)).map(({ location_id, ...rest }: any) => rest)

        if (payload?.some(item => item?.mr_unit_id === null)) {
            toast.error("Unit product is required")
            return
        }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/product/product-minmax-global/bulk-upsert", payload),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.detail?.message ?? err.response.data.message
                }
            ).then(() => {
                props.refecth && props.refecth();
            }).catch(() => {
            }).finally(resolve)
        })

    }

    return (
        <Button
            color="primary"
            permission={PERMISION.INVENTORY.TRANSACTION.SET_STOCK_GLOBAL.CREATE}
            onClick={onSubmit}
            disabled={Boolean(selectedRows.length === 0)}
        >
            SAVE
        </Button>
    )
}